import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api } from "@/lib/api";
import { BookingsManager } from "@/components/admin/BookingsManager";
import { CalendarAdjustments } from "@/components/admin/CalendarAdjustments";
import { PaymentsRevenue } from "@/components/admin/PaymentsRevenue";
import { ActivityLog } from "@/components/admin/ActivityLog";
import { BookingStatusControl } from "@/components/admin/BookingStatusControl";
import { PricingForm } from "@/components/admin/PricingForm";
import { PhotosManager } from "@/components/admin/PhotosManager";
import { ContentForm } from "@/components/admin/ContentForm";
import { SyncPanel } from "@/components/admin/SyncPanel";
import { Stats } from "@/components/admin/Stats";

const TABS = [
  ["reservations", "Reservations", BookingsManager], ["calendar", "Calendar Adjustments", CalendarAdjustments], ["payments", "Payments & Revenue", PaymentsRevenue],
  ["pricing", "Pricing & Policies", PricingForm], ["photos", "Photos", PhotosManager], ["content", "Content", ContentForm], ["sync", "Airbnb Sync", SyncPanel],
  ["activity", "Activity", ActivityLog], ["stats", "Stats", Stats],
];

export default function AdminDashboard() {
  const nav = useNavigate();
  const [user, setUser] = useState(null);
  const [settings, setSettings] = useState(null);
  const loadSettings = () => api.get("/admin/settings").then((r) => setSettings(r.data));
  useEffect(() => {
    document.title = "Owner Dashboard | Garage Getaway Beaumont";
    api.get("/auth/me").then((r) => { setUser(r.data); loadSettings(); }).catch(() => { localStorage.removeItem("owner_token"); nav("/admin/login"); });
  }, [nav]);
  if (!user || !settings) return <div className="p-10 text-sm text-muted-foreground" data-testid="admin-loading">Loading dashboard…</div>;
  const logout = () => { localStorage.removeItem("owner_token"); nav("/admin/login"); };
  return (
    <div className="min-h-screen bg-[hsl(var(--cream))]" data-testid="admin-dashboard">
      <header className="bg-white border-b border-border px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="font-serif text-xl">Garage Getaway <span className="italic text-[hsl(var(--sage))]">Beaumont</span> <span className="text-xs font-sans text-muted-foreground ml-2">Owner</span></Link>
        <div className="flex items-center gap-4 text-sm"><span className="hidden sm:inline text-muted-foreground">{user.email}</span><button onClick={logout} className="underline" data-testid="admin-logout-button">Sign out</button></div>
      </header>
      <Tabs defaultValue="reservations" className="max-w-7xl mx-auto px-5 sm:px-8 py-8">
        <BookingStatusControl settings={settings} reload={loadSettings} />
        <TabsList className="flex flex-wrap h-auto bg-white border border-border justify-start">
          {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} data-testid={`admin-tab-${v}`}>{l}</TabsTrigger>)}
        </TabsList>
        {TABS.map(([v, , C]) => (
          <TabsContent key={v} value={v} className="mt-6"><C settings={settings} reload={loadSettings} /></TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
